var _path;
import * as React from "react";
function SvgVial(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.845 15.344L24.631 4.157a.535.535 0 00-.753 0l-2.267 2.26a.535.535 0 000 .753l.747.74L6.197 24.038c-2.587 2.58-3.007 6.8-.627 9.567 1.373 1.6 3.3 2.4 5.227 2.393 1.76 0 3.52-.666 4.86-2.006L32.078 17.61l.747.74a.535.535 0 00.753 0l2.267-2.26a.527.527 0 000-.747zm-10.647 4.66H14.73l9.868-9.847 5.233 5.22-4.633 4.627z"
  })));
}
export default SvgVial;